import { render, staticRenderFns } from "./CoPlanHistory.vue?vue&type=template&id=20e83a9c&scoped=true&"
import script from "./CoPlanHistory.vue?vue&type=script&lang=ts&"
export * from "./CoPlanHistory.vue?vue&type=script&lang=ts&"
import style0 from "./CoPlanHistory.vue?vue&type=style&index=0&id=20e83a9c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e83a9c",
  null
  
)

export default component.exports